<template>
  <el-date-picker
    v-model="date"
    type="daterange"
    range-separator="至"
    start-placeholder="開始日"
    end-placeholder="結束日"
    :default-time="['00:00:00', '23:59:59']"
    value-format="yyyy-MM-dd"
    :clearable="false"
    @change="onChange"
    @click="
      this.date = null;
      onChange;
    "
  />
</template>
<script>
import dayjs from 'dayjs';
const methods = {
  onChange() {
    if (this.date) {
      const dateConvert = [this.date[0] + ' 00:00:00', this.date[1] + ' 23:59:59'];
      this.$emit('onSelect', dateConvert);
    } else {
      this.$emit('onSelect', this.date);
    }
  },
};
export default {
  data() {
    return {
      date: '',
    };
  },
  created() {
    const start = dayjs().subtract(1, 'week').format('YYYY-MM-DD');
    const now = dayjs().format('YYYY-MM-DD');
    this.date = [start, now];
    this.onChange();
  },
  methods,
};
</script>
